import { Button, Checkbox, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";

export function MultiStorylineReport({ allStorylines }){

    const [storylines, setStorylines] = useState(allStorylines);
    const [selectedStorylines, setSelectedStorylines] = useState([]);

    let [firstDate, setFirstDate] = useState(new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10));
    let [lastDate, setLastDate] = useState(new Date().toISOString().substring(0, 10));


    function handleSelectionChanged(storyline, selected){
        console.log(selectedStorylines + " " + storyline + " " + selected + " " + selectedStorylines.includes(storyline));
        if(selected && (!selectedStorylines.includes(storyline))){
            const newStorylines = [];
            for(const s of selectedStorylines){
                newStorylines.push(s);
            }
            newStorylines.push(storyline);
            setSelectedStorylines(newStorylines);
        }
        else if(!selected && selectedStorylines.includes(storyline)){
            const newStorylines = [];
            for(const current of selectedStorylines){
                if(current != storyline){
                    newStorylines.push(current);
                }
            }
            setSelectedStorylines(newStorylines);
        }
    }

    const handleGenerateClicked = async (event: MouseEvent) => {
        let fileName = await StorylineServerProxy.multiStorylinesReport(selectedStorylines, firstDate, lastDate);
        window.open(new URL(StorylineServerProxy.getURLBase()).origin + "/reports/" + fileName.fileName);
    }    
    

    return <>
        Select storylines:<br/>
        {
            storylines.map(storyline => { return storyline == "" ? <></> :
            <>
                <Checkbox onChange={() => handleSelectionChanged(storyline, event?.target.checked)}></Checkbox>{storyline} <br/>
            </>
            })
        }
        <br />
        <TextField sx={{ width: 1/2 }} label={"First date"} value={firstDate} onChange={event => {setFirstDate(event.target.value)}}/>
        <TextField sx={{ width: 1/2 }} label={"Last date"} value={lastDate} onChange={event => {setLastDate(event.target.value)}}/>
        <br />
        <br />
        <Button onClick={handleGenerateClicked}>Generate report</Button>
    </>
}